(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.SeedCompanyDialogController = (function(superClass) {
    extend(SeedCompanyDialogController, superClass);

    function SeedCompanyDialogController(scope, transitions, modalInstance, service, q, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.q = q;
      this.http = http;
      this.save = bind(this.save, this);
      SeedCompanyDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Add New Seed Company';
      this.scope.absolute_errors = false;
      this.http.get('backend/admin/new-tools/companies/get-countries').then((function(_this) {
        return function(response) {
          _this.scope.countries = response.data;
          return console.log(_this.scope.countries);
        };
      })(this));
      this.scope.name = '';
      this.scope.country = 'United States';
    }

    SeedCompanyDialogController.prototype.save = function(pretend) {
      if (pretend == null) {
        pretend = false;
      }
      if (!pretend) {
        this.scope.$emit('save');
      }
      return this.service.saveSeedCompany(pretend, this.scope.name, this.scope.country).then((function(_this) {
        return function(response) {
          _this.scope.validationErrors = null;
          if (!pretend) {
            return _this.closeWithAlert(response.data.status, response.data.data);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          if (response.status === 422) {
            _this.scope.validationErrors = response.data;
          }
          return _this.q.reject();
        };
      })(this));
    };

    return SeedCompanyDialogController;

  })(DialogController);

}).call(this);
